module.exports = __webpack_public_path__ + "img/buildLogo.becf9284.png";